import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PillComponent } from '../../../../pill/pill.component';
import { ColorProp, getColor } from '../../../../../../layout/Colors';

export interface DataTableFilterPillState {
  filterId?: string;
  text?: string;
}

@Component({
  selector: 'app-data-table-filter-pill',
  templateUrl: './data-table-filter-pill.component.html',
  styleUrls: ['./data-table-filter-pill.component.scss'],
  standalone: true,
  imports:[ PillComponent ]
})
export class DataTableFilterPillComponent {

  @Input() filterState!: DataTableFilterPillState;
  @Input() disable!: BehaviorSubject<boolean>;

  @Output() closeClickEvent = new EventEmitter<string>();

  getColor = getColor;
  colorProp = ColorProp;

  onCloseClick() {
    this.closeClickEvent.emit(this.filterState.filterId);
  }
}